app.factory('sidebarSwiper', function() {

    function SidebarSwipe(){
        this.hidden        = false;
        this.topMenu       = angular.element(document.getElementById('tipsbtn'));
        this.previews      = angular.element(document.getElementById('preview-container'));
        this.sidebar       = angular.element(document.getElementById('sidebar'));
        this.infobtn       = angular.element(document.getElementById('infobtn'));
        this.sidebarWidth  = this.sidebar[0].offsetWidth;
        this.maxOffset     = -this.sidebarWidth;
        this.currentOffset = this.maxOffset;
        this.updateStyle(0);
    }

    angular.extend(SidebarSwipe.prototype,{
        getOffset: function(movement){
            if(this.hidden){
                movement += this.maxOffset;
            }
            return Math.min(0,Math.max(this.maxOffset,movement));
        },
        updateStyle: function(value){
            this.currentOffset = value;
            this.previewValue = (this.sidebarWidth/2) + (value/2);
            this.sidebar.css({
                '-webkit-transform': 'translate3d('+value + 'px,0,0)',
                '-ms-transform': 'translate3d('+value + 'px,0,0)',
                '-moz-transform': 'translate3d('+value + 'px,0,0)',
                'transform': 'translate3d('+value + 'px,0,0)'
            });
            this.previews.css({
                '-webkit-transform': 'translate3d('+ this.previewValue + 'px,0,0)',
                '-moz-transform': 'translate3d('+ this.previewValue + 'px,0,0)',
                '-ms-transform': 'translate3d('+ this.previewValue + 'px,0,0)',
                'transform': 'translate3d('+ this.previewValue + 'px,0,0)'
            });
            this.topMenu.css({
                '-webkit-transform': 'translate3d('+(this.sidebarWidth + value) + 'px,0,0)',
                '-moz-transform': 'translate3d('+(this.sidebarWidth + value) + 'px,0,0)',
                '-ms-transform': 'translate3d('+(this.sidebarWidth + value) + 'px,0,0)',
                'transform': 'translate3d('+(this.sidebarWidth + value) + 'px,0,0)'
            });
            this.infobtn.css({
                '-webkit-transform': 'translate3d('+(this.sidebarWidth + value) + 'px,0,0)',
                '-moz-transform': 'translate3d('+(this.sidebarWidth + value) + 'px,0,0)',
                '-ms-transform': 'translate3d('+(this.sidebarWidth + value) + 'px,0,0)',
                'transform': 'translate3d('+(this.sidebarWidth + value) + 'px,0,0)'
            });
        },
        start: function(){
            /*
            this.topMenu.addClass('notransition');
            this.previews.addClass('notransition');
            this.sidebar.addClass('notransition');
            this.active = true;
            */
        },
        move: function(dir, deltaX){
            switch(dir){
                case "l":
                    this.updateStyle(this.maxOffset);
                    this.hidden = true;
                    break;
                case "r":
                    this.updateStyle(0);
                    this.hidden = false;
                    break;
            }
            /*
            var newOffset = this.getOffset(deltaX);
            this.updateStyle(newOffset);
            */
        },
        end: function(){
            /*
            this.topMenu.removeClass('notransition');
            this.previews.removeClass('notransition');
            this.sidebar.removeClass('notransition');
            if(this.currentOffset < (this.maxOffset/2)){
                this.updateStyle(this.maxOffset);
                this.hidden = true;
            } else {
                this.updateStyle(0);
                this.hidden = false;
            }*/
        }
    });

    return SidebarSwipe;
});
